import { render, staticRenderFns } from "./DShareScormDownload.vue?vue&type=template&id=125edab6&scoped=true&"
import script from "./DShareScormDownload.vue?vue&type=script&lang=js&"
export * from "./DShareScormDownload.vue?vue&type=script&lang=js&"
import style0 from "./DShareScormDownload.vue?vue&type=style&index=0&id=125edab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125edab6",
  null
  
)

export default component.exports